{
  "version": 1,
  "asset_id": "2f0a87e9-36ef-460b-9bc3-b3e77b443d7d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2f0a87e9-36ef-460b-9bc3-b3e77b443d7d/band-tubing-1600.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2f0a87e9-36ef-460b-9bc3-b3e77b443d7d/band-tubing-1600.webp",
  "original_filename": "band-tubing-1600.webp",
  "size": 56174,
  "content_type": "image/webp",
  "created_at": "2026-09-20T00:21:07Z"
}
